import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import { VoiceChatProvider } from './components/VoiceChatButton';
import Navigation from './components/Navigation';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import FeaturesSection from './components/FeaturesSection';
import StatsSection from './components/StatsSection';
import TestimonialsSection from './components/TestimonialsSection';
import WhyChooseSection from './components/WhyChooseSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import VoiceChatButton from './components/VoiceChatButton';
import AboutUs from './pages/AboutUs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';
import { corporateTheme } from './themes/corporate';

const AppContainer = styled.div`
  background: ${corporateTheme.backgroundGradient};
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  font-family: ${corporateTheme.fontFamily};
  color: ${corporateTheme.textPrimary};
`;

// Home page component
const HomePage = () => (
  <>
    <HeroSection />
    <ServicesSection />
    <FeaturesSection />
    <StatsSection />
    <TestimonialsSection />
    <WhyChooseSection />
    <ContactSection />
  </>
);

function App() {
  return (
    <Router>
      <VoiceChatProvider>
        <AppContainer>
          <Navigation />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
          </Routes>
          <Footer />
          <VoiceChatButton />
        </AppContainer>
      </VoiceChatProvider>
    </Router>
  );
}

export default App; 